import * as React from "react"
import { GripVerticalIcon } from "lucide-react"
import { Group, Panel, Separator } from "react-resizable-panels"

import { cn } from "@/lib/utils"

function ResizablePanelGroup({
  className,
  ...props
}) {
  return (
    <Group
      data-slot="resizable-panel-group"
      className={cn(
        "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
        className
      )}
      {...props} />
  );
}

function ResizablePanel({
  ...props
}) {
  return <Panel data-slot="resizable-panel" {...props} />;
}

function ResizableHandle({
  withHandle,
  className,
  ...props
}) {
  const elementRef = React.useRef(null)

  React.useEffect(() => {
    const element = elementRef.current
    if (!element) return

    // Override the native focus to prevent scroll jumping
    const originalFocus = element.focus.bind(element)
    element.focus = (options) => {
      originalFocus({ ...options, preventScroll: true })
    }

    return () => {
      element.focus = originalFocus
    }
  }, [])

  return (
    <Separator
      elementRef={elementRef}
      data-slot="resizable-handle"
      className={cn(
        "relative flex w-3 items-center justify-center focus-visible:outline-hidden",
        "after:absolute after:inset-y-0 after:left-1/2 after:w-px after:-translate-x-1/2 after:bg-transparent data-[scrolled]:after:bg-input after:transition-[background-color,box-shadow] after:duration-300 after:ease-in-out",
        "hover:after:bg-input hover:after:shadow-[0_0_0_1px_var(--color-input)] active:after:bg-input active:after:shadow-[0_0_0_1px_var(--color-input)]",
        "data-[panel-group-direction=vertical]:h-3 data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:inset-x-0 data-[panel-group-direction=vertical]:after:inset-y-auto data-[panel-group-direction=vertical]:after:top-1/2 data-[panel-group-direction=vertical]:after:h-px data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0",
        "[&[data-panel-group-direction=vertical]>div]:rotate-90",
        className
      )}
      {...props}>
      {withHandle && (
        <div
          className="bg-border z-10 flex h-4 w-3 items-center justify-center rounded-xs border">
          <GripVerticalIcon className="size-2.5" />
        </div>
      )}
    </Separator>
  );
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle }
